"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRegistryContractAddress = void 0;
var _LaunchpadProvider_1 = require("../../LaunchpadProvider");
var useWeb3_1 = require("../../shared/hooks/useWeb3");
function useRegistryContractAddress(key) {
    var registry = (0, _LaunchpadProvider_1.useLaunchpadProvider)().registry;
    var chainId = (0, useWeb3_1.useWeb3Provider)().defaultChain.id;
    if (!registry[chainId]) {
        throw new Error("The \"".concat(chainId, "\" is not specified in the registry"));
    }
    var data = registry[chainId][key];
    if (typeof data === "string") {
        if (!data) {
            console.warn("".concat(key, " contract address is not specified in the \"").concat(chainId, "\" chain"));
        }
        return { addresses: [data], version: "" };
    }
    var addresses = data.addresses, version = data.version;
    if (!addresses.length) {
        console.warn("".concat(key, " contract address is not specified in the \"").concat(chainId, "\" chain"));
    }
    return { addresses: addresses, version: version };
}
exports.useRegistryContractAddress = useRegistryContractAddress;
